"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getDatesBetween = exports.dateTimeFormat = exports.dateFormat = exports.customerHintLeftMargin = exports.consuptionsRandomizer = exports.averagePowerAdder = exports.averagePercentageAdder = void 0;
exports.getOrdinalSuffix = getOrdinalSuffix;
exports.unwrapGraphQlList = exports.minMaxRandomizer = exports.getTickValuesFromMax = void 0;

var _lodash = require("lodash");

var _luxon = require("luxon");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var unwrapGraphQlList = function unwrapGraphQlList(obj, pathToEdges) {
  return (0, _lodash.get)(obj, pathToEdges, []).map(function (edge) {
    return edge.node;
  });
};

exports.unwrapGraphQlList = unwrapGraphQlList;

var dateFormat = function dateFormat(dateTime) {
  return dateTime.invalid ? '' : dateTime.toLocaleString(_luxon.DateTime.DATE_SHORT);
};

exports.dateFormat = dateFormat;

var dateTimeFormat = function dateTimeFormat(dateTime) {
  return dateTime.invalid ? '' : dateTime.toLocaleString(_luxon.DateTime.DATETIME_SHORT);
};

exports.dateTimeFormat = dateTimeFormat;

var getDatesBetween = function getDatesBetween(dateRange, settings, timeMeasurementUnit) {
  var multipler = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;
  var startDate = dateRange.startDate,
      endDate = dateRange.endDate;
  var count = _luxon.Interval.fromDateTimes(startDate, endDate).count(timeMeasurementUnit) / multipler;
  var dateTimes = (0, _lodash.range)(count).map(function (x, index) {
    return startDate.plus(_defineProperty({}, timeMeasurementUnit, index * multipler)).set(settings);
  });
  return dateTimes;
}; // https://stackoverflow.com/questions/13627308/add-st-nd-rd-and-th-ordinal-suffix-to-a-number/13627586


exports.getDatesBetween = getDatesBetween;

function getOrdinalSuffix(i) {
  var onesPosition = i % 10;
  var valueMod100 = i % 100;

  if (onesPosition === 1 && valueMod100 !== 11) {
    return "".concat(i, "st");
  }

  if (onesPosition === 2 && valueMod100 !== 12) {
    return "".concat(i, "nd");
  }

  if (onesPosition === 3 && valueMod100 !== 13) {
    return "".concat(i, "rd");
  }

  return "".concat(i, "th");
}

var getTickValuesFromMax = function getTickValuesFromMax(roundedMaxValue) {
  return [1, 2, 3, 4, 5].map(function (tick) {
    return tick / 5 * roundedMaxValue;
  });
};

exports.getTickValuesFromMax = getTickValuesFromMax;

var customerHintLeftMargin = function customerHintLeftMargin(selectedCoord, coords) {
  // Account for the axis on the left now
  // If the hint is for one of the first two entries, we need to adjust it's placement
  if (coords && coords.length > 0 && selectedCoord.x === coords[0].x) {
    return -18;
  }

  if (coords && coords.length > 1 && selectedCoord.x === coords[1].x) {
    return -55;
  }

  return -79;
};

exports.customerHintLeftMargin = customerHintLeftMargin;

var minMaxRandomizer = function minMaxRandomizer(perfData) {
  return perfData.map(function (reading) {
    var num1 = Math.random() * (100 - 75) + 75;
    var num2 = Math.random() * (60 - 35) + 35;
    return _objectSpread(_objectSpread({}, reading), {}, {
      maxBatteryPercentageState: "".concat(num1),
      minBatteryPercentageState: "".concat(num2)
    });
  });
};

exports.minMaxRandomizer = minMaxRandomizer;

var consuptionsRandomizer = function consuptionsRandomizer(prodData) {
  return prodData.map(function (reading) {
    var num1 = Math.random() * (0.3 - 0.1) + 0.1;
    var num2 = Math.random() * (0.15 - 0.05) + 0.05;
    var num3 = Math.random() * (0.1 - 0.01) + 0.01;
    return _objectSpread(_objectSpread({}, reading), {}, {
      estimatedConsumptionKwh: "".concat(num1),
      estimatedSelfConsumptionKwh: "".concat(num2),
      feedInKwh: "".concat(num3)
    });
  });
};

exports.consuptionsRandomizer = consuptionsRandomizer;

var averagePercentageAdder = function averagePercentageAdder(perfData) {
  return perfData.map(function (reading) {
    return _objectSpread(_objectSpread({}, reading), {}, {
      averageBatteryPercentageState: "".concat((Number(reading.maxBatteryPercentageState) + Number(reading.minBatteryPercentageState)) / 2)
    });
  });
};

exports.averagePercentageAdder = averagePercentageAdder;

var averagePowerAdder = function averagePowerAdder(perfData) {
  var lengthInThirds = perfData.length / 3;
  return perfData.map(function (reading, index) {
    var num = Math.random() * (0.5 - 0.01) + 0.01;
    var posOrNegNum = index > lengthInThirds && index < lengthInThirds * 2 ? num : -num;
    return _objectSpread(_objectSpread({}, reading), {}, {
      averagePowerKw: "".concat(posOrNegNum)
    });
  });
};

exports.averagePowerAdder = averagePowerAdder;